document.addEventListener('DOMContentLoaded', function() {

  const pageIndex = document.querySelector('.page-index');
  const sliderIndex = document.querySelector('.slider-index');
  const headerBack = document.querySelector('.j_header-back');
  const isTransparent = document.querySelector('.is-transparent');

  if (!pageIndex || !isTransparent || !sliderIndex || !headerBack) return;

  function checkHeaderPosition() {
    const sliderRect = sliderIndex.getBoundingClientRect();
    const sliderBottom = sliderRect.bottom - 200;

    const headerRect = headerBack.getBoundingClientRect();
    const headerTop = headerRect.top;

    if (headerTop >= sliderBottom) {
      headerBack.classList.remove('is-transparent');
    } else {
      headerBack.classList.add('is-transparent');
    }
  }

  window.addEventListener('scroll', checkHeaderPosition);
  window.addEventListener('resize', checkHeaderPosition);
  checkHeaderPosition();
  

const backTop = document.querySelector('.back-top');
let ticking = false;

const update = () => {
  backTop.classList.toggle('is-show', window.scrollY > window.innerHeight);
  ticking = false;
};

window.addEventListener('scroll', () => {
  if (!ticking) {
    requestAnimationFrame(update);
    ticking = true;
  }
}, { passive: true });

backTop.addEventListener('click', () => {
  window.scrollTo({ top: 0, behavior: 'smooth' });
});

update(); 
  
});